import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punemumbaicabhire() {



const cardData = {
  keyword: " Pune Mumbai Car Hire",

headingDescription:
  "Velocity Cab offers convenient and reliable Pune Mumbai car hire services, providing comfortable transportation for business trips, airport transfers, family outings, or leisure travel. Our professional drivers, well-maintained vehicles, and timely pickups ensure a smooth and stress-free journey between Pune and Mumbai. We offer flexible rental options, including one-way trips, round trips, and hourly packages, with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate groups. With easy online booking and 24/7 customer support, Velocity Cab is your trusted choice for Pune Mumbai car hire services.",

topPlaces: [
  
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is a popular seaside destination in Mumbai, famous for its sandy shores, vibrant street food, and stunning sunsets. Car hire services from Pune allow travelers to reach the beach comfortably without worrying about parking or crowded transport."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple, dedicated to Lord Ganesha, is a revered spiritual site in Prabhadevi. Visitors using Pune Mumbai car hire often stop here for blessings and to admire the temple’s architecture and serene atmosphere."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "The Bandra Worli Sea Link is an architectural marvel connecting Bandra and Worli with panoramic sea and skyline views. Travelers using Pune Mumbai car hire can enjoy a smooth and scenic drive across this landmark."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous mosque and tomb on a small island off Mumbai’s coast, connected by a narrow walkway. Car hire from Pune provides convenient access for visitors wishing to explore this spiritual site."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are UNESCO World Heritage rock-cut temples on Elephanta Island, known for their intricate carvings and historical significance. Travelers can use a car hire service from Pune to reach the Gateway of India and then take the ferry to the caves."
  },
  {
    title: "Gateway of India",
    description:
      "The Gateway of India is one of Mumbai’s most iconic landmarks, located along the Arabian Sea in South Mumbai. Travelers using Pune Mumbai car hire can conveniently reach this historic monument for sightseeing, photography, and ferry trips to Elephanta Island."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive, also known as the Queen’s Necklace for its sparkling nighttime lights, is a scenic coastal road ideal for evening drives and sunset views. Hiring a car from Pune to Mumbai makes visiting this picturesque promenade easy and comfortable."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large urban forest reserve with trekking trails, wildlife, and historic Kanheri Caves. Car hire services from Pune allow easy access to this green retreat for nature enthusiasts and adventure seekers."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a bustling shopping street in South Mumbai with markets, street vendors, and cafes. Travelers using Pune Mumbai car hire can conveniently explore this vibrant area for shopping, dining, and sightseeing."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also called Pherozeshah Mehta Gardens, are beautifully landscaped terraces on Malabar Hill offering panoramic views of Marine Drive and the Arabian Sea. Travelers hiring a car from Pune can reach this peaceful spot easily for photography and relaxation."
  }
],



services: [
{
name: "Mumbai Pune Car Rental Services",
description: "Mumbai Pune car rental services offer reliable transportation between the two major cities of Maharashtra. Well-maintained vehicles with professional drivers ensure safe and comfortable journeys via the Mumbai–Pune Expressway. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, tourism trips, and family visits. Air-conditioned vehicles ensure relaxed long-distance travel. Flexible booking options allow passengers to reserve rides easily anytime."
},
{
name: "Pune Mumbai Pune Car Rental",
description: "Pune Mumbai Pune car rental service provides convenient round-trip transportation for travelers planning return journeys between the two cities. Vehicles are comfortable and suitable for highway travel with experienced drivers ensuring safe driving services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for corporate meetings, tourism trips, and family travel. Flexible rental packages allow easy round-trip travel planning."
},
{
name: "Pune Mumbai Innova Rental",
description: "Pune Mumbai Innova rental service offers spacious SUV transportation for passengers seeking comfort and reliability. Innova vehicles provide ample seating and luggage space suitable for family trips and corporate travel. Professional drivers ensure safe driving and punctual pickup services along the expressway. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient SUV ride reservations."
},
{
name: "Pune Mumbai Velocity Cabs Car Hire",
description: "Pune Mumbai Velocity Cabs car hire service offers dependable intercity transportation with comfortable vehicles and professional drivers. Vehicles are suitable for expressway travel ensuring smooth and safe journeys between Pune and Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travelers, tourists, and families. Flexible booking options allow convenient car hire reservations."
},
{
name: "Pune to Mumbai Cab Hire",
description: "Pune to Mumbai cab hire service provides reliable transportation for travelers planning trips between Pune and Mumbai. Vehicles are well maintained and suitable for long-distance highway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for business trips, tourism visits, and family travel. Flexible booking options allow easy cab reservations."
},
{
name: "Pune to Mumbai Drop Cab",
description: "Pune to Mumbai drop cab service offers convenient one-way transportation for passengers traveling from Pune to Mumbai. Comfortable vehicles with experienced drivers ensure safe and punctual expressway journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for airport transfers, business trips, and tourism travel. Flexible booking options allow quick drop cab reservations."
},
{
name: "Pune to Mumbai Private Cab",
description: "Pune to Mumbai private cab service offers personalized travel experiences with comfortable vehicles and professional drivers. Private transportation ensures privacy and flexibility for passengers traveling between Pune and Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for corporate executives, families, and tourists. Flexible booking options allow convenient ride scheduling."
},
{
name: "Pune to Mumbai Taxi Booking",
description: "Pune to Mumbai taxi booking service allows travelers to easily reserve taxis for comfortable intercity travel. Online booking options make it simple to confirm rides with transparent pricing. Vehicles are well maintained and suitable for highway travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travelers, tourists, and families. Flexible booking options ensure convenient ride planning."
},
{
name: "Pune Mumbai Airport Car Rental",
description: "Pune Mumbai airport car rental service offers comfortable transportation for passengers traveling to or from Mumbai Airport. Vehicles provide spacious seating and luggage space suitable for airport journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, and railway stations in Pune. Flexible booking options allow convenient airport car reservations."
},
{
name: "Pune to Mumbai Darshan Cab",
description: "Pune to Mumbai darshan cab service offers comfortable transportation for travelers visiting temples and sightseeing destinations between Pune and Mumbai. Vehicles are suitable for long-distance travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for pilgrimage tours and family travel. Flexible booking options allow convenient darshan travel planning."
},
{
name: "Pune to Mumbai Car Rental",
description: "Pune to Mumbai car rental service offers convenient vehicle hire options for travelers planning intercity journeys. Vehicles are well maintained and suitable for expressway travel with experienced drivers ensuring safe driving services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for tourism travel, corporate trips, and family visits. Flexible booking options allow easy car reservations."
},
{
name: "Pune to Mumbai Car Booking",
description: "Pune to Mumbai car booking service allows travelers to quickly reserve comfortable vehicles for highway journeys. Online booking options ensure easy reservations with transparent pricing. Vehicles are suitable for long-distance travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient travel planning."
},
{
name: "Pune to Mumbai Car on Rent",
description: "Pune to Mumbai car on rent service provides reliable vehicle rental options for travelers traveling between the two cities. Vehicles are well maintained and suitable for expressway travel with professional drivers ensuring smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business trips, tourism travel, and family journeys. Flexible rental packages allow easy ride reservations."
},
{
name: "Pune to Mumbai Car Hire Charges",
description: "Pune to Mumbai car hire charges services provide transparent pricing information for travelers planning intercity trips. Passengers receive clear fare details including per-kilometer rates, toll charges, and driver allowances. Vehicles are comfortable and suitable for long-distance highway travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient travel planning."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious SUV transportation for families and small groups traveling between Pune and Mumbai. The Ertiga vehicle provides comfortable seating and luggage space suitable for expressway travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient SUV ride reservations."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service provides premium SUV transportation for comfortable long-distance travel. Innova vehicles offer spacious seating and smooth ride quality suitable for expressway journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient ride reservations."
},
{
name: "Pune Mumbai Car Rental",
description: "Pune Mumbai car rental service offers dependable transportation for travelers traveling between Pune and Mumbai. Vehicles are comfortable and suitable for expressway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, tourism visits, and family trips. Flexible booking options allow convenient car rental reservations."
},
{
name: "Pune to Mumbai Cab",
description: "Pune to Mumbai cab service provides reliable and comfortable transportation along the Mumbai–Pune Expressway. Vehicles are well maintained and suitable for long-distance travel with experienced drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for corporate travel, tourism visits, and family trips. Flexible booking options allow easy cab reservations."
},
{
name: "One Way Cab Pune to Mumbai",
description: "One way cab Pune to Mumbai service provides convenient single-trip transportation for passengers traveling between the two cities. Vehicles are suitable for highway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for airport transfers, business travel, and tourism visits. Flexible booking options allow quick one-way ride reservations."
},
{
name: "Pune to Mumbai Cheapest Cab",
description: "Pune to Mumbai cheapest cab service offers budget-friendly travel options for passengers looking for economical transportation. Vehicles provide comfortable seating and reliable highway travel at affordable rates. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow cost-effective ride reservations."
},
{
name: "Pune to Mumbai Cab Fare",
description: "Pune to Mumbai cab fare services provide transparent pricing for travelers planning trips between Pune and Mumbai. Passengers receive clear details about trip costs, toll charges, and driver allowances before confirming bookings. Vehicles are comfortable and suitable for highway travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient ride reservations."
},
{
name: "Pune to Mumbai Cab Charges",
description: "Pune to Mumbai cab charges services help travelers estimate travel costs for intercity journeys between Pune and Mumbai. Transparent pricing ensures passengers know the fare before booking. Vehicles are comfortable and suitable for expressway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow easy travel planning."
},
{
name: "Pune to Mumbai Cab Price",
description: "Pune to Mumbai cab price services allow passengers to compare different vehicle options and choose suitable travel plans. Vehicles are well maintained and suitable for long-distance highway travel with experienced drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient cab reservations."
}
],

tableData: [
["Mumbai Pune Car Rental Services","Pune Mumbai Pune Car Rental"],
["Pune Mumbai Innova Rental","Pune Mumbai Velocity Cabs Car Hire"],
["Pune to Mumbai Cab Hire","Pune to Mumbai Drop Cab"],
["Pune to Mumbai Private Cab","Pune to Mumbai Taxi Booking"],
["Pune Mumbai Airport Car Rental","Pune to Mumbai Darshan Cab"],
["Pune to Mumbai Car Rental","Pune to Mumbai Car Booking"],
["Pune to Mumbai Car on Rent","Pune to Mumbai Car Hire Charges"],
["Pune to Mumbai Ertiga Cab","Pune to Mumbai Innova Cab"],
["Pune Mumbai Car Rental","Pune to Mumbai Cab"],
["One Way Cab Pune to Mumbai","Pune to Mumbai Cheapest Cab"],
["Pune to Mumbai Cab Fare","Pune to Mumbai Cab Charges"],
["Pune to Mumbai Cab Price","Pune to Mumbai Car Rental"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Intercity Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who frequently travel between Pune and Mumbai via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely travel for customers."
  },
  {
    WhyChooseheading: "Transparent Car Hire Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Pune Mumbai car hire services. Customers receive clear fare details including toll charges and driver allowances before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Car Hire Availability",
    WhyChoosedescription: "Our Pune Mumbai car hire service operates 24 hours a day. Whether you need an early morning trip, late night travel, or urgent business travel, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Cars",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and relaxing travel experience between Pune and Mumbai."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Booking",
    WhyChoosedescription: "Velocity Cabs offers flexible car hire options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans between Pune and Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and railway stations across Pune including areas like Baner, Hinjewadi, Wakad, Kharadi, Hadapsar, Viman Nagar, and Pimpri Chinchwad."
  },
  {
    WhyChooseheading: "Trusted Pune Mumbai Travel Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Pune Mumbai car hire thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Pune Mumbai car hire service?", answer: "Yes, Velocity Cabs provides reliable car hire services between Pune and Mumbai for business and leisure travel." },
  { question: "Is Pune Mumbai car hire available 24 hours?", answer: "Yes, our car hire service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Pune Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way car hire?", answer: "Yes, we provide both one-way and round-trip car hire options between Pune and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and railway stations across Pune." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the car hire service online?", answer: "Yes, customers can easily book Pune Mumbai car hire services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides direct drop services to Mumbai Airport and other locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "A very comfortable experience with Pune to Mumbai car hire service. The vehicle was clean, punctual, and the highway journey felt smooth and relaxed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "The Pune to Mumbai car hire service was reliable and well-managed. The ride was steady, the driver was professional, and everything felt safe and stress-free.",
    rating: 5
  }
];











































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Mumbai Car Hire Service | Velocity Cabs",
  "description": "Velocity Cabs provides the best Pune to Mumbai car hire service with affordable pricing and professional drivers. Book private car rentals including sedan, Ertiga, Innova, and Innova Crysta for one way, round trip, airport transfers, and outstation travel. Enjoy safe, comfortable, and reliable Pune to Mumbai car rental services with easy booking options.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Pune Mumbai Car Hire | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Pune Mumbai car hire with Velocity Cabs. Affordable car rental service with sedan, Ertiga, Innova & Crysta options. Reliable, safe & comfortable Pune to Mumbai taxi and car rental service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punemumbaicabhire;